import classnames from 'classnames'
import { bool, node, string } from 'prop-types'

const SubmenuCardTitle = ({ children, visuallyHidden, classes }) => (
  <h3
    className={classnames(
      'a-h3',
      'u-no-margin--bottom',
      'u-padding-large--ends@medium',
      'u-padding-small--ends@small-tiny',
      'u-padding-large--sides@small-tiny',
      classes,
      { 'u-visuallyhidden': visuallyHidden }
    )}
  >
    {children}
  </h3>
)

SubmenuCardTitle.propTypes = {
  visuallyHidden: bool,
  classes: string,
  children: node.isRequired,
}

export default SubmenuCardTitle
